export default "__VITE_ASSET__CCPvCtzc__"